import React, { useEffect, useState } from "react";
import { Form, Formik, FormikHelpers } from "formik";
import { array, object, string } from "yup";
import { FollowUpFormValues } from "src/models/FollowUp.model";
import FollowUpForm from "../Layouts/FollowUpForm";
import { useAddFollowUpMutation } from "src/services/FollowUpServices";
import { showToast } from "src/utils/showToaster";
import { useNavigate, useParams } from "react-router-dom";
import { useViewInquiryQuery } from "src/services/InquiryServices";
import moment from "moment";

const AddFollowUpFormWrapper = () => {
  const { inquiryId = "" } = useParams();
  const navigate = useNavigate();

  const [addFollowUp] = useAddFollowUpMutation();
  const [inquiryDataState, setInquiryData] = useState<any>();

  const {
    data: inquiryData,
    isLoading: InquiryisLoading,
    isFetching: InquiryisFetching,
  } = useViewInquiryQuery(inquiryId);

  useEffect(() => {
    if (!InquiryisLoading && !InquiryisFetching) {
      setInquiryData(inquiryData?.data);
    }
  }, [inquiryData, InquiryisLoading, InquiryisFetching]);

  // Form Initial Values
  const initialValues: FollowUpFormValues = {
    is_communicated: "",
    inquiryLabel:'',
    communication_summary: "",
    communication_method: "",
    interest_level: "",
    next_followUp_required: "",
    contact_them: "",
    next_followUp_date: "",
    next_followup_time: "",
    new_batch_start: false,
    followup_batch_start_course: [],
    next_followup_reason: "",
    course_not_clear: false,
    interested_course: inquiryDataState?.interested_course?.map((el: any) => {
      return {
        course_name: {
          label: el?.courseLabel?.courseName,
          value: el?.course_name,
        },
        fees: el?.fees,
        Offer_Price: el?.Offer_Price,
        remark: el?.remark,
      };
    }),
    disposition_one: "",
    disposition_two: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    is_communicated:string().required('please select communicated') ,
    communication_method:string().required('Please select communication method'),
    communication_summary:string().test(
      "address-test",
      "summary  is required",
      (value, context) => { 
        const { is_communicated } = context.parent;
        // const pervious = perviousMembershipPrice;
        if (is_communicated === "YES" && !value) {
          return false;
        }
        return true;
      }
    ),
    next_followUp_required: string().required('Please select next followup is required'),

    interested_course: array().of(
      object({
        course_name: object().required('please select course name'),
        fees: string().required('please enter total fees'),
        Offer_Price: string().required('please enter offer fees'),
      }),
    ),
    disposition_one: string().required('please select disposition one') ,
    disposition_two: string().required('please select disposition two') ,
    inquiryLabel : object().required('please select inquiry label') ,
  });

  // Handle Submit
  const handleSubmit = (
    values: FollowUpFormValues,
    { setSubmitting, resetForm }: FormikHelpers<FollowUpFormValues>
  ) => {
    const formattedValues = {
      inquiry_id: inquiryId,
      name: inquiryDataState?.name ,
      mobile : inquiryDataState?.mobile ,
      is_communicated: values?.is_communicated,
      inquiryLabelId : values?.inquiryLabel?.value,
      communication_summary: values?.communication_summary,
      communication_method: values?.communication_method,
      interest_level: values?.interest_level,
      next_followUp_required: values?.next_followUp_required,
      contact_them: values?.contact_them,
      next_followUp_date:values?.next_followUp_date ?  moment(values?.next_followUp_date).format('yyyy-MM-DD')  : '',
      next_followup_time:values?.next_followup_time ?  moment(values?.next_followup_time).format("hh:mm A") : '',
      new_batch_start: values?.new_batch_start,
      followup_batch_start_course: values?.followup_batch_start_course?.map(
        (course: any) => course.value
      ),
      next_followup_reason: values?.next_followup_reason,
      course_not_clear: values?.course_not_clear,
      interested_course: values?.interested_course?.map((el: any) => {
        return {
          course_name: el?.course_name === "" ? null : el?.course_name?.value,
          fees: el?.fees?.toString(),
          Offer_Price: el?.Offer_Price,
          remark: el?.remark,
        };
      }),
      disposition_one:
        values?.disposition_one === "" ? null : values?.disposition_one,
      disposition_two:
        values?.disposition_two === "" ? null : values?.disposition_two,
    };

    addFollowUp(formattedValues).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          navigate(`/inquiries/edit/${inquiryId}/followup`);
          resetForm();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <FollowUpForm formikProps={formikProps} />
          </Form>
        )}
      </Formik>
  );
};

export default AddFollowUpFormWrapper;
